import React, { JSX } from "react";
import { ErrorMessage, FieldConfig, useField } from "formik";

import { LockIcon } from "src/assets/icons/lock_icon";

import "./input.scss";

/*
 * Types
 */

type FieldProps = JSX.IntrinsicElements["input"] & FieldConfig<string>;

export type InputProps = {
    readonly label?: string;
    readonly readOnly?: boolean;
    renderLabelMeta?: () => React.ReactNode;
} & FieldProps;

/*
 * Main
 */

export const Input = (props: InputProps): React.ReactElement => {
    const { id, label, name, readOnly = false, renderLabelMeta, ...rest } = props;
    const [field, meta] = useField(props);

    return (
        <div className="input-wrap">
            <label hidden={!label} htmlFor={id || name}>
                {label ?? label}
                {renderLabelMeta && (
                    <>
                        {" — "}
                        {renderLabelMeta()}
                    </>
                )}
            </label>
            <input
                className={meta.error && meta.touched ? "error" : undefined}
                data-testid={field.name}
                id={id || name}
                readOnly={readOnly}
                {...field}
                {...rest}
            />
            {readOnly && <LockIcon />}
            <div className="input-field-error">
                <ErrorMessage name={field.name} />
            </div>
        </div>
    );
};
